export function haversineDistanceKm(lat1, lng1, lat2, lng2) {
    const toRad = (deg) => (deg * Math.PI) / 180;
    const R = 6371;
    const dLat = toRad(lat2 - lat1);
    const dLng = toRad(lng2 - lng1);
    const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}

// Normalizes AnnouncementMemberService responses (member + team + response fields)
// into the roster row shape used by the team leader / staff response board tables.
export function buildRoster(announcementMembers, incidentLat, incidentLng) {
    return announcementMembers.map((am) => {
        const member = am.member || {};
        const lat = Number.parseFloat(member.lat);
        const lng = Number.parseFloat(member.lng);
        const hasLocation = incidentLat != null && incidentLng != null && !Number.isNaN(lat) && !Number.isNaN(lng);
        const distanceKm = hasLocation
            ? haversineDistanceKm(lat, lng, Number.parseFloat(incidentLat), Number.parseFloat(incidentLng))
            : null;

        let status = 'Pending';
        if (am.accepted === true) status = 'Accepted';
        else if (am.accepted === false) status = 'Rejected';

        return {
            id: am.id,
            name: member.fullname || 'Unknown',
            initials: (member.fullname || '?').charAt(0).toUpperCase(),
            role: member.role?.role_name || 'Unknown',
            hasRole: !!member.role?.role_name,
            status,
            eta: am.eta ? new Date(am.eta).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '—',
            battery: member.batteryPercent != null ? `${member.batteryPercent}%` : '—',
            distance: distanceKm != null ? `${distanceKm.toFixed(1)} km` : '—',
            team: am.team?.name || '—',
            roleConfirmed: !!am.roleConfirmed,
            roles: am.roles || [],
            donningChecklist: am.donningChecklist || {},
            ppeNumber: am.ppeNumber || '',
            tldNumber: am.tldNumber || '',
            radiationInitialReading: am.radiationInitialReading || '',
            doffingChecklist: am.doffingChecklist || {},
            followUpReading: am.followUpReading || '',
            finalReading: am.finalReading || '',
            finalStatus: am.finalStatus || '',
            exitedZoneAt: am.exitedZoneAt || null,
            doffingCompletedAt: am.doffingCompletedAt || null,
            zoneId: am.zoneId || null,
            zoneName: am.zone?.name || null,
            activeSince: am.ata || null,
            ppeDonnedAt: am.ppeDonnedAt || null,
        };
    });
}

export function processTeamData(teams) {
    return teams.map(team => {
        const membersCount = team.members.length;
        const roleCounts = team.members.reduce((acc, member) => {
            const roleName = member.role.role_name;
            if (!acc[roleName]) {
                acc[roleName] = 0;
            }
            acc[roleName]++;
            return acc;
        }, { doctors: 0, nurses: 0, rsos: 0 });

        return {
            id:team.id,
            name: team.name,
            totalMembers: membersCount,
            admins: roleCounts.admins || 0,
            doctors: roleCounts.doctors || 0,
            nurses: roleCounts.nurses || 0,
            rsos: roleCounts.rsos || 0,
            readinessLevel: team.readinessLevel,
            readinessLevelId: team.readinessLevelId,
            hospitalFacilityId: team.hospitalFacilityId,
            hospitalName: team.hospitalName,
        };
    });
}